// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  ${(props) =>
    props.borderBottom
      ? `@media ${props.theme.mediaQuery.medium}{
          border-bottom: 1px solid ${props.theme.colorPalette.gray[500]};
          padding-bottom: ${props.theme.spacing.ELEM_SPACING.XL}};
        }`
      : ``};
  margin-bottom: ${(props) =>
    props?.isLoginV2FlowEnabled
      ? props.theme.spacing.ELEM_SPACING.MED
      : props.theme.spacing.ELEM_SPACING.XL};
  input {
    background-color: ${(props) =>
      props.variation === 'secondary' ? props.theme.colorPalette.gray[300] : ''};
  }
  .phone-field-wrapper {
    position: relative;
  }
  .phone-prefix {
    position: absolute;
    top: ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};
    left: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    z-index: 0;
  }
  .phone-field {
    left: ${(props) => props.theme.spacing.LAYOUT_SPACING.SM};
  }
  .send-order-update {
    display: flex;
  }
  .rich-text {
    font-size: ${(props) => `${props.theme.fonts.fontSize.body.small.secondary}px`};
    margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
    width: 100%;
    font-family: ${(props) => props.theme.fonts.secondaryFontFamily};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      margin-left: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    }
  }
  .spc-order-update {
    @media (max-width: ${(props) => props.theme.breakpoints.smallMax}) {
      font-size: ${(props) => `${props.theme.fonts.fontSize.body.bodytext.copy3}px`};
    }
  }
`;

export default styles;
